module.exports = __webpack_public_path__ + "static/youth-venture-ffacf45f2d2100e7321318807fdaad9a.jpg";